import HttpService from './baseHttp'
// 通知中心
//读取用户通知状态
export const HttpNoticeStats = (data = {}) => HttpService.get("/api/v1/BizNotify/stats", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//读取用户通知最近消息
export const HttpRecentNoticeList = (data = {}) => HttpService.get("/api/v1/BizNotify/recent", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//读取通知消息详情
export const HttpNotice = (data = {}) => HttpService.get("/api/v1/BizNotify/loadData", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//标记收件条目已读
export const HttpReadNotice = (data = {}) => HttpService.post('/api/v1/BizNotify/markAsRead', data, { baseURL: process.env.VUE_APP_APIURL_UC });
//通知收件条目列表分页展示
export const HttpNoticeList = (data = {}) => HttpService.get("/api/v1/BizNotify/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });

// 系统公告
//读取用户公告状态
export const HttpAnnounceStats = (data = {}) => HttpService.get("/api/v1/BizAnnouncement/stats", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//读取用户公告最近消息
export const HttpRecentAnnounceList = (data = {}) => HttpService.get("/api/v1/BizAnnouncement/recent", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//读取公告消息详情
export const HttpAnnounce = (data = {}) => HttpService.get("/api/v1/BizAnnouncement/loadData", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
//标记收件条目已读
export const HttpReadAnnounce = (data = {}) => HttpService.post('/api/v1/BizAnnouncement/markAsRead', data, { baseURL: process.env.VUE_APP_APIURL_UC });
//公告收件条目列表分页展示
export const HttpAnnounceList = (data = {}) => HttpService.get("/api/v1/BizAnnouncement/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });


// 通知模板列表分页展示
export const HttpTemplateList = (data = {}) => HttpService.get("/api/v1/UcRemindTemplate/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 获取单条数据
export const HttpTemplate = (data = {}) => HttpService.get("/api/v1/UcRemindTemplate/loadData", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 删除
export const HttpDelTemplate = (data = {}) => HttpService.get("/api/v1/UcRemindTemplate/del", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 判断标书是否存在
export const HttpCheckTemplate = (data = {}) => HttpService.get("/api/v1/UcRemindTemplate/checkCodeExists", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 编辑/创建
export const HttpSaveTemplate = (data = {}) => HttpService.post("/api/v1/UcRemindTemplate/saveData", data, { baseURL: process.env.VUE_APP_APIURL_UC });
// 设置状态
export const HttpSetActiveTemplate = (data = {}) => HttpService.post("/api/v1/UcRemindTemplate/setActive", data, { baseURL: process.env.VUE_APP_APIURL_UC });

// 通知规则
// 通知规则列表分页展示
export const HttpRuleList = (data = {}) => HttpService.get("/api/v1/UcRemindRule/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 根据ID load出通知规则信息
export const HttpRule = (data = {}) => HttpService.get("/api/v1/UcRemindRule/loadData", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 删除通知规则
export const HttpDelRule = (data = {}) => HttpService.get("/api/v1/UcRemindRule/del", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 判断标书是否存在
export const HttpCheckRule = (data = {}) => HttpService.get("/api/v1/UcRemindRule/checkCodeExists", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 创建/更新通知规则
export const HttpSaveRule = (data = {}) => HttpService.post("/api/v1/UcRemindRule/saveData", data, { baseURL: process.env.VUE_APP_APIURL_UC });
// 根据ID load出通知规则信息
export const HttpUserList = (data = {}) => HttpService.get("/api/v1/User/findByPageOrIds", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 规则测试事件生成
export const HttpBizeventGen = (data = {}) => HttpService.get("/status/notify/gen", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 设置状态
export const HttpSetActiveRule = (data = {}) => HttpService.post("/api/v1/UcRemindRule/setActive", data, { baseURL: process.env.VUE_APP_APIURL_UC });

// 任务提示
export const HttpNoticeTaskList = (data = {}) => HttpService.get("/api/v1/TaskCenter/findList", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 获取单个最新的导出任务
export const HttpAllTaskExport = (data = {}) => HttpService.get('/api/v1/TaskCenter/findByUser', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 任务详情
export const HttpTaskCenter = (data = {}) => HttpService.get('/api/v1/TaskCenter/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取报表单独任务下载
export const HttpTaskReport = (data = {}) => HttpService.get('/api/v1/ReportTask/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })

// 报表通知
export const HttpReportList = (data = {}) => HttpService.get('/api/v1/ReportTask/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })
